import * as React from 'react'

import { cn } from '@/lib/utils'

const brandGradientClass =
  'gwt-brand-gradient text-white shadow-[0_12px_32px_-6px_rgba(107,33,168,.55),0_4px_16px_-4px_rgba(251,146,60,.4)] hover:opacity-[0.94] disabled:pointer-events-none disabled:opacity-60'

type GradientButtonProps = {
  children: React.ReactNode
  href?: string
  className?: string
  variant?: 'filled' | 'outline' | 'white'
  type?: 'button' | 'submit'
  disabled?: boolean
}

export function GradientButton({
  children,
  href,
  className,
  variant = 'filled',
  type = 'button',
  disabled,
}: GradientButtonProps) {
  const base =
    variant === 'filled'
      ? brandGradientClass
      : variant === 'white'
        ? 'bg-white text-brand-purple shadow-md hover:bg-white/95'
        : 'border border-white/80 bg-white/10 text-white backdrop-blur-sm hover:bg-white/20'

  const cls = cn(
    'inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition',
    base,
    className,
  )

  if (href) {
    return (
      <a data-component-id="src/components/agencies-landing/shared.tsx:40:6" data-component-path="src/components/agencies-landing/shared.tsx" data-component-line="40" data-component-end-line="42" data-component-file="shared.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%2C%22className%22%3A%22%5Bvar%3Acls%5D%22%7D" href={href} className={cls}>
        {children}
      </a>
    )
  }

  return (
    <button data-component-id="src/components/agencies-landing/shared.tsx:47:4" data-component-path="src/components/agencies-landing/shared.tsx" data-component-line="47" data-component-end-line="49" data-component-file="shared.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22className%22%3A%22%5Bvar%3Acls%5D%22%7D" type={type} disabled={disabled} className={cls}>
      {children}
    </button>
  )
}

export function SectionBadge({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <p data-component-id="src/components/agencies-landing/shared.tsx:55:4" data-component-path="src/components/agencies-landing/shared.tsx" data-component-line="55" data-component-end-line="62" data-component-file="shared.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D"
      className={cn(
        'inline-flex rounded-full bg-blue-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-600',
        className,
      )}
    >
      {children}
    </p>
  )
}
